// src/components/ProductsPage/requests.js
import { authFetch } from "../api/api";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export const PRODUCTS_URL = `${BASE_URL}/api/products/`;
export const CITIES_URL = `${BASE_URL}/api/cities/`;
export const SUPPLIERS_URL = `${BASE_URL}/api/suppliers/suppliers/`;

async function readError(response, fallback) {
  try {
    const data = await response.json();
    if (typeof data === "string") return data;
    if (data?.detail) return data.detail;
    const lines = Object.entries(data || {}).map(([k, v]) => {
      const msg = Array.isArray(v) ? v.join(", ") : String(v);
      return `${k}: ${msg}`;
    });
    return lines.join("; ") || fallback;
  } catch {
    return fallback;
  }
}

export async function fetchProducts() {
  const r = await authFetch(PRODUCTS_URL);
  if (!r.ok) throw new Error(await readError(r, "Не удалось загрузить товары"));
  const data = await r.json();
  return Array.isArray(data) ? data : data?.results ?? [];
}

export async function fetchProduct(id) {
  const r = await authFetch(`${PRODUCTS_URL}${id}/`);
  if (!r.ok) throw new Error(await readError(r, "Не удалось загрузить товар"));
  return r.json();
}

export async function fetchCities() {
  try {
    const r = await authFetch(CITIES_URL);
    if (!r.ok) return [];
    const data = await r.json();
    return Array.isArray(data) ? data : data?.results ?? [];
  } catch {
    return [];
  }
}

export async function fetchSuppliers() {
  try {
    const r = await authFetch(SUPPLIERS_URL);
    if (!r.ok) return [];
    const data = await r.json();
    return Array.isArray(data) ? data : data?.results ?? [];
  } catch {
    return [];
  }
}

export function buildProductFormData(editingProduct) {
  const formData = new FormData();
  const productData = { ...editingProduct };

  if (productData.production_city_text?.trim()) {
    formData.append("production_city_text", productData.production_city_text);
  } else if (productData.production_city) {
    formData.append("production_city", productData.production_city);
  }

  Object.keys(productData).forEach((key) => {
    if (["id", "production_city", "production_city_text"].includes(key)) return;

    if (key === "suppliers") {
      (productData.suppliers || []).forEach((id) => {
        if (id) formData.append("supplier_id", id);
      });
      return;
    }

    if (key === "image") {
      if (productData.image instanceof File) {
        formData.append("image", productData.image);
      }
      return;
    }

    if (
      productData[key] !== null &&
      productData[key] !== undefined &&
      productData[key] !== ""
    ) {
      formData.append(key, productData[key]);
    }
  });

  return formData;
}

export async function createProduct(formData) {
  const r = await authFetch(PRODUCTS_URL, { method: "POST", body: formData });
  if (!r.ok) throw new Error(await readError(r, "Не удалось создать товар"));
  return r.json();
}

export async function updateProduct(id, formData) {
  const r = await authFetch(`${PRODUCTS_URL}${id}/`, {
    method: "PATCH",
    body: formData,
  });
  if (!r.ok) throw new Error(await readError(r, "Не удалось сохранить товар"));
  return r.json();
}

export async function deleteProduct(id) {
  const r = await authFetch(`${PRODUCTS_URL}${id}/`, { method: "DELETE" });
  if (!r.ok) throw new Error(await readError(r, "Не удалось удалить товар"));
  return true;
}

export { BASE_URL };